<template>

  <div style="margin-top: 25px;" >
    <el-breadcrumb separator-class="el-icon-arrow-right" style="display: flex; justify-content: center; align-items: center;">
      <el-breadcrumb-item :to="{ path: '/' }">不空动画</el-breadcrumb-item>
      <el-breadcrumb-item>人物素材</el-breadcrumb-item>
      <el-breadcrumb-item style="flex: 1; text-align: left;">
        <div style="display: inline-flex;">
          <el-input placeholder="请输入查询内容" v-model="mc" id="txtMC" style="width: 260px;"></el-input>
          <el-button round @click="btnQuery(4)" style="margin-left: 10px;">检 索</el-button>
        </div>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="el-row is-justify-center el-row--flex">
      <el-button round @click="btnQuery(0)">全部</el-button>
      <el-button round @click="btnQuery(1)">都市人物</el-button>
      <el-button round @click="btnQuery(4)">年代人物</el-button>
      <el-button round @click="btnQuery(2)">古代人物</el-button>
      <el-button round @click="btnQuery(3)">Q版人物</el-button>
    </div>


    <div style="margin-top: 5px;">
      <div id="product" class="container-fluid productStyle">
            <el-row>
              <el-col :span="6" v-for="(o, index) in listData.length" :key="index" class="el-col"  >
                  <el-card shadow="never" style="background:white;border: none;width: 450px;height: 300px;position: relative;" @click.native="btnCard(listData[index].id)">
                    <el-badge value="不空素材版权所有" style="border-radius: 10px;position: absolute;
                    font-size: 40px;width: 30px;height: 20px;">
                    </el-badge>
                    <img :src="listData[index].url "
                         style="border-radius: 5px;border: 1px solid #adadad;object-fit: contain;width: 426px;height: 280px;
                         vertical-align: top;cursor: pointer;">
                    <el-button type="primary" size="mini" style="position: absolute; bottom: 50px; right: 10px;" @click.stop="copyImage(listData[index].id)">
                      复制
                    </el-button>

                  </el-card>
                  <div style="padding: 14px;font-size: 20px;">
                    <span>{{ listData[index].mc }}</span>
                  </div>
              </el-col>
            </el-row>
          </div>
      </div>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>

    <el-dialog title="不空素材网" width="960px" modal="false" append-to-body modal-append-to-body="false" :visible.sync="ImaDialog">
      <el-form :model="form">
        <el-form-item label="图 片" :label-width="formLabelWidth">
          <el-image :src="form.fileurl"></el-image>
        </el-form-item>
        <el-form-item label="下 载" :label-width="formLabelWidth">
          <el-button type="primary" @click="btnDownload">下 载</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>

  </template>
<style>
  .card-col{
    border: 2px solid #ebeef5;
    border-radius: 10px;
  }
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
import {addCopyProd, addProd, prodInfo, prodInfo2, prodList, prodListAuth} from '../../api/bkProd'
import {getStore, setStore} from "../../utils/util";

export default {
  data() {
    return {
      ImaDialog:false,

      form:{
        mc:"",
        fileurl:"",
        fileurl2:"",
        fileurl3:""
      },
      fl:1,
      fl2:0,
      mc:"",
      listData:[{id:0, mc:'',url:''}],
      pageIndex: 1, // 当前页码
      pageSize: 12, // 每页显示条数
      total: 0 // 总数据条数
    }
  },
  methods: {
    copyImage(prodId) {
      var id = getStore("id",id);
      var account = getStore("account",account);
      var token = getStore("token",token);

      if(id===""||account===""||token===""||
        id===null||account===null||token===null){
        this.$store.state.showLoginDialog = true;
      }
      else{

        var postData = {
          prodId : prodId
        };

        addCopyProd(postData).then((res)=>{
          if(res.State === 1){
            this.$message.success('复制成功！请在AN中使用不空插件进行粘贴！');

          }
          else{
            this.$message.error(res.ErrorMessage);
          }
        });

      }

      /*navigator.clipboard.writeText(url).then(() => {
        this.$message.success('图片URL已复制到剪贴板');
      }).catch(err => {
        this.$message.error('复制失败');
        console.error('复制失败:', err);
      });*/
    },
    btnQuery(type){
      if(type!=4) {
        this.fl2 = type;
      }
      var id = getStore("id",id);
      var account = getStore("account",account);
      var token = getStore("token",token);

      if(id===""||account===""||token===""||
        id===null||account===null||token===null){
        prodList({mc:this.mc,fl:1,fl2:this.fl2,pageIndex:this.pageIndex,pageSize:this.pageSize}).then((res)=>{
          this.listData = res.Data.data;
          this.total = res.Data.total;
        });
      }
      else {
        prodListAuth({mc:this.mc,fl:1,fl2:this.fl2,pageIndex:this.pageIndex,pageSize:this.pageSize}).then((res)=>{
          this.listData = res.Data.data;
          this.total = res.Data.total;
        });
      }
    },
    btnCard(prodid) {
      var id = getStore("id",id);
      var account = getStore("account",account);
      var token = getStore("token",token);
      // 在这里执行你的逻辑
      if(id===""||account===""||token===""||
        id===null||account===null||token===null){
        this.$store.state.showLoginDialog = true;
      }
      else{
        this.ImaDialog = true;

        prodInfo2({id:prodid}).then((res)=>{
          this.form.mc = res.Data.mc;
          this.form.fileurl = res.Data.fileurl;
          this.form.fileurl2 = res.Data.fileurl2===""?res.Data.fileurl:res.Data.fileurl2;
          this.form.fileurl3 = res.Data.fileurl3;
        });
      }
    },
    btnDownload(){
      const fileUrl =this.form.fileurl3!==""?this.form.fileurl3: this.form.fileurl2; // 文件的URL地址
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', this.form.mc);
      link.click();
    },
    getRowLength(index) {
      const start = (index - 1) * 5;
      const end = start + 5;
      return end > this.data.length ? this.data.length - start : 5;
    },
    getprodlist(){
      var id = getStore("id",id);
      var account = getStore("account",account);
      var token = getStore("token",token);

      if(id===""||account===""||token===""||
        id===null||account===null||token===null){
        prodList({mc:this.mc,fl:1,fl2:this.fl2,pageIndex:this.pageIndex,pageSize:this.pageSize}).then((res)=>{
          this.listData = res.Data.data;
          this.total = res.Data.total;
        });
      }
      else {
        prodListAuth({mc:this.mc,fl:1,fl2:this.fl2,pageIndex:this.pageIndex,pageSize:this.pageSize}).then((res)=>{
          this.listData = res.Data.data;
          this.total = res.Data.total;
        });
      }


    },
    handleCurrentChange(newPage){

      var id = getStore("id",id);
      var account = getStore("account",account);
      var token = getStore("token",token);

      if((id===""||account===""||token===""||
        id===null||account===null||token===null)&&newPage>5){
        this.$store.state.showLoginDialog = true;
      }
      else {
        this.pageIndex = newPage;
        this.getprodlist();
      }
    }
  },
  created() {
    // 监听
    // this.$root.Bus.$on('toggle', value => {
    //
    // })
  },
  mounted(){
    this.getprodlist();
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/rwsc/rwsc.vue